import Career from './Career';
import JobDetail from './JobDetail';
import Header from './Header';
import Footer from './Footer';
import { Routes, Route } from 'react-router-dom';
import './App.css';

function App() {
  return (
    <div className="App flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Career />} />
          {/* <Route path="/careers" element={<Career />} /> */}
          <Route path="/:slug" element={<JobDetail />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
